import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import {
	CompanyHistoricalDetailsRequest,
	CompanyHistoricalRequest,
} from "@/main/models/request/companyHistoricalRequest";
import {
	CompanyHistoricalDetailsResponse,
	CompanyHistoricalResponse,
} from "@/main/models/response/companyHistoricalResponse";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class ICompanyHistoricalApi {
	abstract getHistorical(
		request: CompanyHistoricalRequest,
	): Promise<AxiosResponse<PaginationResponse<CompanyHistoricalResponse>>>;

	abstract getHistoricalDetails(
		request: CompanyHistoricalDetailsRequest,
	): Promise<AxiosResponse<Result<CompanyHistoricalDetailsResponse>>>;

	abstract downloadHistoricalFile(guidFileImport: string): Promise<AxiosResponse<Result<any>>>;
}
